import React from "react";
import sridhar from "../assets/sridhar.png";
import sanjay from "../assets/sanjay.png";
import pramod from "../assets/pramod.png";
import pavan from "../assets/pavan.png"
import abhinav from "../assets/AbhinavMittal-HighRES.png"
import Raghu from "../assets/Raghuram.png"
import sudhakarKakunuri from "../assets/Sudhakar Kakunuri.png";
import sathyanarayana from "../assets/Sathyanarayana.png";
import "./OurTeam.css";
import Navbar from "../components/NavBar";
import '@fortawesome/fontawesome-free/css/all.min.css';
import SEO from "../components/SEO";

const advisoryTeam = [
  {
    name: "Sridhar",
    title: "Technology & Leadership",
    description: "Senior leadership positions at TCS, Siemens, CSC, Wells Fargo, and Salesforce. Focuses on leadership development, process maturity, business frameworks and large-scale transformation solutions.",
    imageUrl: sridhar,
  },
  {
    name: "Sanjay",
    title: "HR & Talent Management",
    description: "Extensive experience at Satyam, Mylan, Ashok Leyland, and Dell. Expert in strategic thinking, team dynamics, and organizational performance optimization.",
    imageUrl: sanjay,
  },
  {
    name: "Pramod",
    title: "HR & Talent Development",
    description: "Former leadership roles at TCS, Thales, Wells Fargo, and Brane. Specializes in organizational behavior and strategic talent development initiatives.",
    imageUrl: pramod,
  },
  {
    name: "Pavan",
    title: "Strategic Talent Development Leader",
    description: "With rich experience across Deloitte, Accenture, and GE Capital, Pavan brings deep expertise in leadership development, executive coaching, and organizational transformation to help organizations build high-impact leaders.",
    imageUrl: pavan,
  },
  {
    name: "Abhinav Mittal",
    title: "AI Strategy & Governance Expert",
    description: "Abhinav Mittal is a globally recognized AI Strategy and Governance leader with 20+ years of experience delivering ROI-driven AI transformation. He has advised 20+ CXOs and led 45+ digital and AI programs generating over $100M in value across the Middle East, Europe, and the U.S. ",
    imageUrl: abhinav,
  },
  {
    name: "Raghu Ram Burra",
    title: "Honorary Advisor-Tech & Business Expert",
    description: "Raghu is a seasoned techno-business leader with 30+ years of global experience, having held senior roles at Microsoft, Infosys, GE, CA Technologies (Broadcom), and NCR. He specializes in enterprise transformation and global operating models, and has built and led large Global Capability Centers (2,000+ professionals) with full P&L responsibility across India, APAC, and North America. ",
    imageUrl: Raghu,
  },
];

const technicalAdvisors = [
  {
    name: "Sathyanarayana",
    title: "Full Stack Expert",
    description:
      "Satyanarayana is a distinguished technology leader and corporate trainer with over two decades of experience in enterprise application development and capability building across global organizations. Known for his depth of expertise and impactful delivery, he has consistently enabled technology teams to elevate performance, adopt modern engineering practices, and deliver at scale.",
    imageUrl: sathyanarayana,
    imageClass: "technical-sathya-image",
  },
  {
    name: "Sudhakar Kakunuri",
    title: "Testing & QA Expert",
    description:
      "Sudhakar Kakunuri, widely known as QTP Sudhakar, is a renowned software testing expert and corporate trainer with over two decades of experience in test automation and quality engineering. A pioneer in the field, he has trained thousands of professionals and helped organizations build robust, scalable automation frameworks.",
    imageUrl: sudhakarKakunuri,
    imageClass: "technical-sudhakar-image",
  },
];

const expertProfiles = [
  {
    name: "Sridhar",
    title: "",
    details: "Sridhar focuses on nurturing leadership potential and strengthening team collaboration through tailored, experiential learning interventions. His work integrates practical knowledge with innovative methodologies to inspire individual growth and drive organizational excellence. He collaborates closely with organizations to build process maturity and enable large-scale transformation, aligning people capability with strategic business goals.",
  },
  {
    name: "Sanjay",
    title: "",
    details: "Expertise lies in enhancing Strategic Thinking, Team Dynamics, and Organizational Performance. Known for his dynamic training style, Sanjay empowers individuals and teams to unlock their full potential and achieve sustained success. He plays a pivotal role in advancing process excellence and operational effectiveness.",
  },
  {
    name: "Pramod",
    title: "",
    details: "Specializes in Organizational Behavior and Leadership Strategies, guiding individuals and teams through transformative learning journeys. His approach blends practical insights with engaging methodologies to foster growth, collaboration, and high-impact leadership. Pramod partners with organizations to streamline processes and enable seamless transformation.",
  },
  {
    name: "Pavan",
    title: "",
    details: "An award-winning professional. Pavan has successfully led Talent Development in large, multilocation organizations across IT, BPO, Banking, and Telecom, contributing significantly at Deloitte, Accenture, Cyient, Satyam, ICICI, Tata Teleservices, Airtel, and GE Capital.",
  },
];

const OurExpertsAndAdvisors = () => {
  return (
    <>
      <SEO
        title="Our Team"
        description="Meet the RTS Techsol advisors, technical experts, and select specialists bringing decades of experience across technology, leadership, and talent development."
        path="/ourTeam"
      />
      <Navbar />

      <div className="advisory-section">
        <h2 className="section-heading">Our Mentors & Advisors</h2>
        <p className="advisory-intro-text"> Our advisory team brings decades of leadership experience from globally recognized organizations, providing strategic guidance that shapes our service excellence and innovation approach. </p>

        <div className="team-members-header">
          <span className="team-members-section-badge">Advisors & Board Members</span>
        </div>

        <div className="team-members-container">
          {advisoryTeam.map((member, index) => (
            <div key={index} className="member-card">
              <div className="image-circle-container">
                <img src={member.imageUrl} alt={member.name} className="member-image" />
              </div>
              <h3 className="member-name">{member.name}</h3>
              <p className="member-title">{member.title}</p>
              <p className="member-description">{member.description}</p>
            </div>
          ))}
        </div>

        <div className="team-members-header technical-advisors-header">
          <span className="team-members-section-badge technical-advisors-badge">Technology Advisors</span>
        </div>

        <div className="team-members-container technical-advisors-container">
          {technicalAdvisors.map((member, index) => (
            <div key={index} className="member-card">
              <div className="image-circle-container">
                <img
                  src={member.imageUrl}
                  alt={member.name}
                  className={`member-image ${member.imageClass || ""}`.trim()}
                />
              </div>
              <h3 className="member-name">{member.name}</h3>
              {member.title ? <p className="member-title">{member.title}</p> : null}
              {member.description ? <p className="member-description">{member.description}</p> : null}
            </div>
          ))}
        </div>
      </div>
      <div className="experts-section-container">
        <header className="experts-header">
          <div className="logo-placeholder"></div>
          <h1 className="main-heading">Brief Profile of Our Select Experts</h1>
        </header>
        <div className="expert-cards-wrapper">
          {expertProfiles.map((expert, index) => (
            <div key={index} className="expert-card">
              <h3 className="expert-name-title">
                {expert.name} <span className="expert-title-emphasis">{expert.title}</span>
              </h3>
              <p className="expert-details">{expert.details}</p>
            </div>
          ))}
        </div>
        <div className="join-team-section-container">
          <div className="join-team-content">


            <h2 className="team-heading">Join Our Team</h2>


            <p className="team-pitch-text">
              We're always looking for talented individuals passionate about making a difference in corporate training and development.
            </p>


            <div className="team-contact-link">
              <a href="mailto:careers@rtstechsol.com">

                <i className="fas fa-envelope"></i>
                <span>info@rtstechsol.com</span>
              </a>
            </div>

          </div>
        </div>
        <div className="summary-box">
          <p className="summary-text"> Our team of experts includes over a dozen seasoned professionals with extensive experience as heads of Technology, Talent & Business Functions in diversified domains across globally renowned organizations such as Wells Fargo, HSBC, Ashok Leyland, Mylan, Tech Mahindra, Poonawala, Karvy, Adobe, DXC, Bank of America, and Franklin Templeton. Together, they bring a cumulative expertise of 250+ man-years, combining strategic insights and industry best practices to deliver impactful learning experiences. </p>
        </div>
      </div>
    </>
  );
};

export default OurExpertsAndAdvisors;
